import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

// Products screen shows its own Snackbar → opt mutations out of the global
// duplicate SUCCESS toast; keep global ERROR as the safety net.
const SN = { skipNotify: 'success' };

export const fetchProducts = createAsyncThunk(
  'product/fetchProducts',
  async ({ page = 1, limit = 25, search = '', category = '', city = '', status = '', brand = '' }, { rejectWithValue }) => {
    try {
      const response = await axios.get('/admin/products', {
        params: {
          page,
          limit,
          search: search || undefined,
          category: category || undefined,
          city: city || undefined,
          status: status || undefined,
          brand: brand || undefined
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.msg || 'Failed to fetch products');
    }
  }
);

export const createProduct = createAsyncThunk(
  'product/createProduct',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post('/admin/products', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }, ...SN
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.msg || 'Failed to create product');
    }
  }
);

export const updateProduct = createAsyncThunk(
  'product/updateProduct',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post('/admin/products/update', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }, ...SN
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.msg || 'Failed to update product');
    }
  }
);

export const deleteProduct = createAsyncThunk(
  'product/deleteProduct',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`/admin/products/${id}`, SN);
      return { id, msg: response.data.msg };
    } catch (error) {
      return rejectWithValue(error.response?.data?.msg || 'Failed to delete product');
    }
  }
);

export const bulkDeleteProducts = createAsyncThunk(
  'product/bulkDeleteProducts',
  async (ids, { rejectWithValue }) => {
    try {
      const response = await axios.post('/admin/products/bulk-delete', { ids }, SN);
      return { ids, msg: response.data.msg };
    } catch (error) {
      return rejectWithValue(error.response?.data?.msg || 'Failed to delete products');
    }
  }
);


const initialState = {
  products: [],
  totalProducts: 0,
  currentPage: 1,
  totalPages: 0,
  isLoading: false,
  error: null,
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.products = action.payload.products;
        state.totalProducts = action.payload.totalProducts;
        state.currentPage = action.payload.currentPage;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default productSlice.reducer;
